import { Component } from "react";
import styles from "./inputDate.module.css";
import InputBase from "@material-ui/core/InputBase";
import classnames from "classnames";
import { debounce } from "lodash";
import renderHTML from "html-react-parser";
import { _t } from "src/redux/store";

type Props = {
  classname?: string;
  name: string;
  value: string;
  label: string;
  info?: string;
  handleOnChange: Function;
};

type FieldName = "dayValue" | "monthValue";

type State = {
  value: string;
  phone: string;
  yearValue: string;
  monthValue: string;
  dayValue: string;
  input: {
    isValid: boolean;
    warning: string;
  };
};

class InputDate extends Component<Props, State> {
  maxDate = new Date();
  constructor(props: Props) {
    super(props);
    this.state = {
      value: "",
      yearValue: "",
      monthValue: "",
      dayValue: "",
      phone: "",
      input: {
        isValid: true,
        warning: "",
      },
    };
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.value !== this.state.value) {
      this.debouncedHandleOnChange();
    }
  }

  debouncedHandleOnChange = debounce(() => {
    this.validateInput(this.state.value);
    if (this.state.input.isValid) {
      this.props.handleOnChange(this.props.name, this.state.value);
    } else {
      this.props.handleOnChange(this.props.name, "");
    }
  }, 200);

  handleOnChange = (val: string, type: 'dayValue' | 'monthValue' | 'yearValue') => {
    let newState = { ...this.state };
    newState[type] = val;
    newState.value = newState.yearValue + '-' + newState.monthValue + '-' + newState.dayValue;

    if (((type === "dayValue" || type === "monthValue") && val.length <= 2) || (type === "yearValue" && val.length <= 4)) {
      this.setState({ ...newState });
    }
  };

  validateInput = (text: string) => {
    // Ensure that day value is valid and adds a 0 if user inputs only one number
    let isValidDay: boolean = false;
    if (this.state.dayValue.length > 0 && this.state.dayValue.length < 3 && parseInt(this.state.dayValue) > 0 && parseInt(this.state.dayValue) <= 31) {
      isValidDay = true;
    }
    // Ensure that month value is valid and adds a 0 if user inputs only one number
    let isValidMonth: boolean = false;
    if (this.state.monthValue.length > 0 && this.state.monthValue.length < 3 && parseInt(this.state.monthValue) > 0 && parseInt(this.state.monthValue) <= 12) {
      isValidMonth = true;
    }

    if (!isValidDay || !isValidMonth) {
      this.setState({
        input: {
          isValid: false,
          warning: (_t.translate("Invalid date"))
        },
      });
      return;
    }

    const date = new Date(text);
    const datePlus18 = new Date(date);
    datePlus18.setFullYear(datePlus18.getFullYear() + 18);
    const nowDate = new Date();
    const isValid = nowDate >= datePlus18;
    this.setState({
      input: {
        isValid: isValid,
        warning: (isValid ? '' : _t.translate("You must be 18 or older"))
      },
    });
  };

  handleBlur = (name: FieldName) => {
    const date = this.state[name];
    if (date.length === 1) {
      this.setState((prevUser) => ({
        ...prevUser,
        [name]: `0${date}`,
      }));
    }
  }

  render() {
    return (
      <div
        className={classnames(
          styles.formControl,
          typeof this.props.classname !== "undefined" && this.props.classname
        )}
      >
        <span className={styles.label}>{this.props.label}</span>
        <label className={styles.inputWrapper}>
          <InputBase
            className={classnames(
              styles.textField,
              !this.state.input.isValid && styles.error
            )}
            onChange={(e) => this.handleOnChange(e.target.value, 'dayValue')}
            value={this.state.dayValue}
            inputProps={{
              className: styles.input,
              disableunderline: "true",
              min: 1,
              max: 31,
              placeholder: _t.translate("Day")
            }}
            type="number"
            onBlur={() => this.handleBlur("dayValue")}
          />
          <span>-</span>
          <InputBase
            className={classnames(
              styles.textField,
              !this.state.input.isValid && styles.error
            )}
            onChange={(e) => this.handleOnChange(e.target.value, 'monthValue')}
            value={this.state.monthValue}
            inputProps={{
              className: styles.input,
              disableunderline: "true",
              min: 1,
              max: 12,
              placeholder: _t.translate("Month")
            }}
            type="number"
            onBlur={() => this.handleBlur("monthValue")}
          />
          <span>-</span>
          <InputBase
            className={classnames(
              styles.textField,
              !this.state.input.isValid && styles.error
            )}
            onChange={(e) => this.handleOnChange(e.target.value, 'yearValue')}
            value={this.state.yearValue}
            inputProps={{
              className: styles.input,
              disableunderline: "true",
              min: 1900,
              max: this.maxDate.getFullYear(),
              placeholder: _t.translate("Year")
            }}
            type="number"
          />
        </label>
        {typeof this.props.info !== "undefined" && (
          <div className={styles.info}>{renderHTML(this.props.info)}</div>
        )}
        {!this.state.input.isValid && (
          <small className={styles.warning}>{this.state.input.warning}</small>
        )}
      </div>
    );
  }
}

export default InputDate;
